import { useNavigate } from 'react-router';
import { IconChevronLeft } from '@tabler/icons-react';
import { ClientsTable } from '../ClientsTable';
import { useFamily } from '../hooks/useFamily';
import { useClientsContext } from 'src/clients/context/ClientsContext';
import { useFlags } from 'src/feature-flags/FlagsHook';

export function FamilyClientsTable({ id }: { id: string }) {
  const { family } = useFamily(id);
  const navigate = useNavigate();
  const title = [family?.name, 'Family'].filter(Boolean).join(' ');
  const { editFamily } = useClientsContext();
  const { flagEnabledFamilyRoleModel } = useFlags();

  // Role-model families can't be edited through the legacy star-shape flow
  // (it wipes members and roles on save), so they use the role-aware edit page.
  const editButton = {
    label: 'Edit family',
    variant: 'default' as const,
    onClick: () => {
      if (!family) return;
      if (flagEnabledFamilyRoleModel) {
        navigate(`/clients/families/${family.id}/edit`);
      } else {
        editFamily(family.id);
      }
    },
  };

  return (
    <ClientsTable
      title={title}
      titleIcon={<IconChevronLeft />}
      onTitleClick={() => {
        navigate(`/clients/families`);
      }}
      filters={{ familyId: id }}
      showViewModes={false}
      primaryButton={editButton}
    />
  );
}
